import React from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, StickyNote, Layers, PlusCircle } from "lucide-react";
import Breadcrumbs from "../components/Breadcrumbs";
import StudyLayout from "../components/StudyLayout";
import NavigationButtons from "../components/NavigationButtons";
import "./CreateContent.css";

const CreateContent = () => {
  const navigate = useNavigate();

  const contentTypes = [
    {
      title: "Lesson",
      description: "Create a lesson",
      icon: BookOpen,
      path: "/content-lesson",
    },
    {
      title: "Note",
      description: "Create a note",
      icon: StickyNote,
      path: "/content-note",
    },
    {
      title: "Flashcard",
      description: "Create a flashcard",
      icon: Layers,
      path: "/content-flashcard",
    },
  ];

  return (
    <StudyLayout
      breadcrumbs={
        <Breadcrumbs
          path={[
            { label: "MySpace", path: "/myspace" },
            {
              label: (
                <span className="create-content-breadcrumb-label">
                  <PlusCircle size={14} />
                  <span>Create</span>
                </span>
              ),
              path: null,
            },
          ]}
        />
      }
      buttons={<NavigationButtons />}
    >
      <div className="create-content-page">
        <div className="create-content-grid">
          {contentTypes.map((type) => {
            const Icon = type.icon;
            return (
              <div
                key={type.title}
                className="create-content-card"
                onClick={() => navigate(type.path)}
              >
                <div className="create-content-card-icon">
                  <Icon size={32} />
                </div>
                <div className="create-content-card-title">{type.title}</div>
                <div className="create-content-card-description">
                  {type.description}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </StudyLayout>
  );
};

export default CreateContent;
